import React from "react";
import { Link } from "react-router-dom";
import { useSearchParams } from "react-router-dom";
import { getBaseUrl } from "./BaseUrl";
function Success() {
  const token = localStorage.getItem("token");
   let base_url =getBaseUrl();
    const [searchParams] = useSearchParams();
  const merchantOrderId = searchParams.get("merchant_order_id");
  return (
    <div
      className="container"
      style={{
        minHeight: "100dvh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <div class="row w-100" style={{ justifyContent: "center" }}>
        <div class="col-lg-6 col-md-8 col-sm-12">
          <div class="cardBox paymentexecutionbox">
            <div class="text-center">
              <div class="payment-success">
                <i class="fa-regular fa-circle-check"></i>
              </div>
              <h4 className="text-white mt-3">Deposit Successfully</h4>
              <p>Your order id: {merchantOrderId}</p>
              <Link
                className="btn bg_btn mt-3"
                to={token ? `${base_url}userdashboard` : base_url}
                state={token ? { from: "real_account" } : ""}
              >
                Start Trading
                {/* <i class="fa-solid fa-arrow-right"></i> */}
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Success;
